<script lang="ts" setup>
const showThankYou = ref(false)

const handleSubmitBookAnAppointment = () => {
  showThankYou.value = true
}

const { deferredBrandTheme } = await useTheme()
</script>
<template>
  <div
    class="text-text-primary bg-book-an-appointment grid-standard justify-center"
    :class="[
      deferredBrandTheme === 'emporio-armani'
        ? 'bg-neutral-black'
        : 'bg-primitives-off-white',
    ]"
  >
    <div
      class="columns-standard gap-lg py-lg md:gap-xl md:py-xl flex flex-col lg:gap-14 lg:py-16"
    >
      <div class="gap-y-md flex flex-col">
        <div class="flex items-end justify-between">
          <h1 class="text-book-5 md:text-book-3 flex-1 uppercase">
            {{ $ts('bookAnAppointment.title') }}
          </h1>
          <span class="text-book-8"
            >*{{ $ts('bookAnAppointment.requiredFields') }}</span
          >
        </div>
        <div class="text-book-6">
          {{ $ts('bookAnAppointment.subTitlePage') }}
        </div>
      </div>
      <div
        class="theme-global-colors bg-primitives-white text-primitives-black p-md md:p-xxl"
      >
        <BookAnAppointmentForm
          v-if="!showThankYou"
          is-page
          form-id="BOOK_AN_APPOINTMENT_FORM_ID_PAGE"
          @submit-book-an-appointment="handleSubmitBookAnAppointment"
        />
        <BookAnAppointmentThankYou v-else />
      </div>
    </div>
  </div>
</template>
